module.exports = __webpack_public_path__ + "img/mesa_l001n.f923ca5c.png";